import React, { useState, useEffect } from 'react'
import { Container, Grid, Paper, Button, Stack, Box, Input, Typography, CircularProgress, Alert } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { DateRange } from 'react-date-range'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import SearchIcon from '@mui/icons-material/Search'
import SearchOffIcon from '@mui/icons-material/SearchOff'
import BackspaceIcon from '@mui/icons-material/Backspace'
import SaveIcon from '@mui/icons-material/Save'
import Copyright from '../../../General/Copyright'
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import {trackingReports, getProcesses} from '../../../Shared/Fetch'

export default function ReportsIndex() {
  const envConfig = {
      url : (process.env.REACT_APP_ENVIROMENT === "prod") ? process.env.REACT_APP_URL_PROD : process.env.REACT_APP_URL_DEV
  };
  const actualDate = new Date()
  const previousDate = new Date(actualDate.getTime() - 3 * 24 * 60 * 60 * 1000)

  const [loading, setLoading] = useState(false)
  const [reports, setReports] = useState(undefined)

  const [carriers, setCarriers] = useState([{ A: 'a' }])
  const [processes, setProcesses] = useState([{ A: 'a' }])
  const [companies, setCompanies] = useState([{ A: 'a' }])
  const [users, setUsers] = useState([{ A: 'a' }])
  
  const [operation, setOperation] = useState({ opMovement: 0 })
  const [companieId, setCompanieId] = useState({ companieId: 0 })
  const [userId, setUserId] = useState({ userId: 0 })
  const [carrierId, setCarrierId] = useState({ carrierId: 0 })

  const [UUIDValue, setUUIDValue] = useState('');
  const [descarga, setDescarga] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: previousDate,
      endDate: actualDate,
      key: 'selection'
    }
  ])
  const carriersOptions = (carriers) => {
    return carriers.map((carrier) => {
      return {
        label: carrier.name,
        value: carrier.id,
      };
    });
  };
  const companieOptions = (companiesArray) => {
    return companiesArray.map((companie) => {
      return {
        label: companie.nombre_comercial,
        value: companie.id,
      };
    });
  };
  const processOptions = (processesArray) => {
    return processesArray.map((process) => {
      return {
        label: process.name,
        value: process.id,
      };
    });
  };
  const userOptions = (itemsArray) => {
    return itemsArray.map((user) => {
      return {
        label: user.name,
        value: user.id,
      };
    });
  };

  // const isValidUUID = value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);
  // const UUIDValue = isValidUUID ? value : null;
  const filters = [
    { id: 'todos', name: 'Todos' },
    { id: 'proceso', name: 'Proceso' },
    { id: 'usuario', name: 'Usuario' },
    { id: 'compania', name: 'Compañía' },
    { id: 'carrier', name: 'Carrier' }
  ];

  async function saveReports() {
    try {
    setLoading(true);
    setDescarga(true);
      const params = new URLSearchParams({
      UUIDValue: UUIDValue,
      userId: userId['userId'],
      companieId: companieId['companieId'],
      operation: operation['opMovement'],
      carrierId: carrierId['carrierId'],
      start: dateRange[0].startDate.toISOString().split('T', 1),
      end: dateRange[0].endDate.toISOString().split('T', 1)
    })
    
    const response = await fetch(`${envConfig.url}/api/v2/reports/save?${params}`, {
      method: 'GET',
      headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
          'Cache-Control': 'no-cache'
      }
  });
  
    if (response.ok) {
      
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `Reporte del ${params.get('start')} hasta el ${params.get('end')}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    }
    setLoading(false)
    
    if (response != null) {
    setReports(response.data)
    }
    }
    catch (error) {
      console.error("Error en la solicitud:", error);
      setReports(null);
    } finally {
      setLoading(false);
    }
  }

  async function getReports() {
    const params = new URLSearchParams({
      UUIDValue: UUIDValue,
      userId: userId['userId'],
      companieId: companieId['companieId'],
      operation: operation['opMovement'],
      carrierId: carrierId['carrierId'],
      start: dateRange[0].startDate.toISOString().split('T', 1),
      end: dateRange[0].endDate.toISOString().split('T', 1)
    })
    setLoading(true);
    await trackingReports(params, setReports);
    setLoading(false);
  }
  
  async function getCarriers() {
    try {
      const response = await fetch(`${envConfig.url}/api/v2/carriers`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          'Cache-Control': 'no-cache'
        }
      });
  
      if (response.ok) {
        const data = await response.json();
        data.data.unshift({ id: 0, name: 'Todos' });
        setCarriers(data.data);
      } else {
        console.error("Error en la respuesta", response);
        setCarriers(null);
      }
    } catch (error) {

      console.error("Error en la solicitud", error);
      setCarriers(null);
    }
  }
      
  async function getUsers() {
    try {
      const response = await fetch(`${envConfig.url}/api/v2/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          'Cache-Control': 'no-cache'
        }
      });
  
      if (response.ok) {
        const data = await response.json();
        let filteredUsers = data.users;
        if (companieId.companieId && companieId.companieId !== 0) {
          filteredUsers = data.users.filter(user => user.empresa_id === companieId.companieId);
        }
        filteredUsers.unshift({ id: 0, name: 'Todos' });
        setUsers(filteredUsers);
      } else {
        console.error("Error en la respuesta", response);
        setUsers([]);
      }
    } catch (error) {

      console.error("Error en la solicitud", error);
      setUsers([]);
    }
  }
  async function getCompanies() {
    try {
      const response = await fetch(`${envConfig.url}/api/v2/companies`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          'Cache-Control': 'no-cache'
        }
      });
  
      if (response.ok) {
        const data = await response.json();
        data.companies.unshift({ id: 0, nombre_comercial: 'Todos' });
        setCompanies(data.companies);
      } else {
        console.error("Error en la respuesta", response);
        setCompanies([]);
      }
    } catch (error) {

      console.error("Error en la solicitud", error);
      setCompanies([]);
    }
  }
  const [isValidUUID, setIsValidUUID] = useState(true);

  const handleUUIDChange = (event) => {
    const value = event.target.value;
    setUUIDValue(value);
  };
  
  useEffect(() => {
    const isValid = (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(UUIDValue)||UUIDValue==='');
    setIsValidUUID(isValid);
  }, [UUIDValue]);

  useEffect(() => {
    getProcesses(setProcesses)
    getCarriers()
    getUsers()
    getCompanies()
  }, [companieId])

  return (
    <Container
      maxWidth='lg'
      sx={{ mt: 4, mb: 4 }}
    >
      {/* Main */}

      <Grid
        container
        spacing={3}
        direction={{ xs: 'column', md: 'row' }}
      >
        {/* Formulario */}
        <Grid
          item
          xs={12}
          md='auto'
        >
          <Paper sx={{ p: 2 }}>
            <Stack
              spacing={2}
              direction={{ xs: 'column', sm: 'row', md: 'column' }}
            >
              {/* Calendario */}
              <DateRange
                editableDateInputs={false}
                sx={{ width: '100%' }}
                onChange={item => setDateRange([item.selection])}
                moveRangeOnFirstSelection={true}
                ranges={dateRange}
              />

              {/* Botones */}
              <Stack
                spacing={2}
                sx={{ width: '100%' }}
              >
                {/* Selector */}
                <Autocomplete
                  disablePortal
                  id="carrier-autocomplete"
                  options={carriersOptions(carriers)}
                  sx={{ width: '100%' }}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) => {
                    setCarrierId({ carrierId : newValue ? newValue.value : 0 });
                  }}
                  renderInput={(params) => <TextField {...params} label="Carriers" />}
                  isOptionEqualToValue={(option, value) => option.value === value}
                  value={carriersOptions(carriers).find(p => p.value === carrierId.carrierId) || null}
                />
                
                <Autocomplete
                  disablePortal
                  id="process-autocomplete"
                  options={processOptions(processes)}
                  sx={{ width: '100%' }}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) => {
                    setOperation({ opMovement: newValue ? newValue.value : 0 });
                  }}
                  renderInput={(params) => <TextField {...params} label="Proceso" />}
                  isOptionEqualToValue={(option, value) => option.value === value}
                  value={processOptions(processes).find(p => p.value === operation.opMovement) || null}
                />
                 
                 <Autocomplete
                    disablePortal
                    id="companie-autocomplete"
                    options={companieOptions(companies)}
                    sx={{ width: '100%' }}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, newValue) => {
                      setCompanieId({ companieId: newValue ? newValue.value : 0});
                    }}
                    renderInput={(params) => <TextField {...params} label="Compañía" />}
                    isOptionEqualToValue={(option, value) => option.value === value}
                    value={companieOptions(companies).find(c => c.value === companieId.companieId) || null}
                  />
                <Autocomplete
                  disablePortal
                  id="user-autocomplete"
                  options={userOptions(users)}
                  sx={{ width: '100%' }}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) => {
                    setUserId({ userId: newValue ? newValue.value :0 });
                  }}
                  renderInput={(params) => <TextField {...params} label="Usuario" />}
                  isOptionEqualToValue={(option, value) => option.value === value}
                  value={userOptions(users).find(u => u.value === userId.userId) || null}
                />
                <Input
                  value={UUIDValue}
                  sx={{ width: '100%', margin: 2 }}
                  onChange={(value) => handleUUIDChange(value)}
                  placeholder="Ingrese un UUID"
                />
                <Alert severity="warning" sx={{ display: isValidUUID ? 'none' : 'block' }}>El UUID no es válido</Alert>

                {/* <p>Valor a enviar: {UUIDValue ? UUIDValue : 'No válido'}</p> */}

                {/* Enviar */}
                <Button
                  variant='contained'
                  type='submit'
                  onClick={() => getReports()}
                  fullWidth={true}
                  disabled={(loading || !isValidUUID)}
                  startIcon={<SearchIcon />}
                >
                  Buscar
                </Button>

                {/* Guardar */}
                {reports?.length > 0 && loading === false && (
                  <Button
                    variant='outlined'
                    color='info'
                    fullWidth={true}
                    type='reset'
                    disabled={loading}
                    startIcon={<SaveIcon />}
                    onClick={saveReports}
                  >
                    Guardar como Excel
                  </Button>
                  
                )}
                {/* Limpiar */}
                <Button
                  variant='outlined'
                  fullWidth={true}
                  type='reset'
                  disabled={loading}
                  color='error'
                  startIcon={<BackspaceIcon />}
                  onClick={() => {
                    setDateRange([
                      {
                        startDate: previousDate,
                        endDate: actualDate,
                        key: 'selection'
                      }
                    ])
                    setOperation({ opMovement: 0 })
                    setCompanieId({ companieId: 0 })
                    setUserId({ userId: 0 })
                    setCarrierId({ carrierId: 0 })
                    setUUIDValue('');
                    setReports(undefined)
                  }}
                >
                  Limpiar
                </Button>
              </Stack>
            </Stack>
          </Paper>
        </Grid>

        {/* Resultados */}
        <Grid
          item
          xs={12}
          md
        >
          <Paper sx={{ width: '100%', height: '100%', minHeight: '30em', p: 2 }}>
            {reports === undefined && loading === false && (
              <Stack
                paddingX={'20%'}
                justifyContent='center'
                alignContent='center'
                sx={{ height: '100%' }}
              >
                <Box>
                  <SearchIcon sx={{ fontSize: 75 }} />
                </Box>
                <Typography variant='h5'>Generar reporte</Typography>
                <Typography variant='body1'>Para empezar, selecciona un rango de fechas y el proceso del que deseas buscar</Typography>
              </Stack>
            )}

            {loading === true && (
              <Stack
                paddingX={'20%'}
                justifyContent='center'
                alignContent='center'
                sx={{ height: '100%' }}
              >
                <Box>
                  <CircularProgress size={75} />
                </Box>
                <Typography variant='h5'>
                  {descarga ? 'Descargando guías' : 'Buscando guías'}
                </Typography>
                <Typography variant='body1'>Espera un momento en lo que encontramos realizamos la búsqueda</Typography>
              </Stack>
            )}

            {reports !== undefined &&
              loading === false &&
              (reports?.length > 0 ? (
                <Box sx={{ height: '100%', width: '100%' }}>
                  <DataGrid
                    rows={reports}
                    columns={[
                      {
                        field: 'date',
                        headerName: 'Fecha',
                        resizable: true,
                        width: 200
                      },
                      {
                        field: 'waybill',
                        headerName: 'Guía',
                        resizable: true,
                        width: 200
                      },
                      {
                        field: 'user',
                        headerName: 'Usuario',
                        resizable: true,
                        width: 200
                      },
                      {
                        field: 'subsidiary',
                        headerName: 'Sucursal',
                        resizable: true,
                        width: 200
                      }
                    ]}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                  />
                </Box>
              ) : (
                <Stack
                  paddingX={'20%'}
                  justifyContent='center'
                  alignContent='center'
                  sx={{ height: '100%' }}
                >
                  <Box>
                    <SearchOffIcon sx={{ fontSize: 75 }} />
                  </Box>
                  <Typography variant='h5'>Sin resultados</Typography>
                  <Typography variant='body1'>No encontramos guías que cumplan los parámetros que solicitaste</Typography>
                </Stack>
              ))}
          </Paper>
        </Grid>
      </Grid>

      {/* Footer */}
      <Grid
        container
        paddingTop={2}
      >
        <Grid
          item
          xs={12}
        >
          <Paper
            sx={{
              p: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: 50
            }}
          >
            <Copyright sx={{ pt: 4 }} />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  )
}
